module.exports = __webpack_public_path__ + "static/zehenaseeb-db67784cdd6923c37f0af2f5dc1c43d1.jpg";